// tslint:disable:max-line-length

import React from 'react';

export const LayoutTable = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M16,0H0v16h16V0z M1.5,1.5h2.2v2.4H1.5V1.5z M4.8,1.5h4.3v2.4H4.8V1.5z M10.2,1.5h4.3v2.4h-4.3V1.5z M1.5,5h2.2v2.4H1.5V5z M4.8,5h4.3v2.4H4.8V5z M10.2,5h4.3v2.4h-4.3V5z M1.5,8.6h2.2V11H1.5V8.6z M4.8,8.6h4.3V11H4.8V8.6z M10.2,8.6h4.3V11h-4.3V8.6z M1.5,12.1h2.2v2.4H1.5V12.1z M4.8,12.1h4.3v2.4H4.8V12.1z M10.2,12.1h4.3v2.4h-4.3V12.1z" />
    </svg>
  );
};
